// src/pages/ApartmentRoomsVilla.jsx
import React, { useState, useEffect } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';

// Import Images (Update the paths to your actual images)
import apartmentVillaImage from '../assets/Villa/Rooms/11.jpg';
import bedroomImage from '../assets/Villa/Rooms/DSC_0542.JPG';
import bathroomImage from '../assets/Villa/Rooms/WhatsApp Image 2025-02-14 at 00.15.14.jpeg';
import kitchenImage from '../assets/Villa/Rooms/DSC_0568.JPG';
import livingImage from '../assets/Villa/Rooms/DSC_0551.JPG';

const rooms = [
    {
        id: 1,
        name: "Bedroom",
        description: "A cozy and comfortable bedroom with a king-size bed and modern decor.",
        icon: "🛏️",
        image: bedroomImage,
    },
    {
        id: 2,
        name: "Bathroom",
        description: "Spacious and luxurious bathroom with premium fittings.",
        icon: "🛁",
        image: bathroomImage,
    },
    {
        id: 3,
        name: "Kitchen",
        description: "Fully equipped modern kitchen for all your culinary needs.",
        icon: "🍽️",
        image: kitchenImage,
    },
    {
        id: 4,
        name: "Living Room",
        description: "A stylish living room with a smart TV and comfortable seating.",
        icon: "🛋️",
        image: livingImage,
    },
];

const ApartmentRoomsVilla = () => {
    const [currentIndex, setCurrentIndex] = useState(0);

    // Auto-slide every 3 seconds
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % rooms.length);
        }, 3000);

        return () => clearInterval(interval);
    }, []);

    return (
        <section className="container my-5">
            {/* Apartment Room with Villa Header */}
            <div className="text-center mb-5">
                <h1 className="display-4 fw-bold" style={{ color: '#819371' }}>Apartment Rooms with Villa</h1>
                <p className="text-muted fs-5">
                    A luxurious stay combining the comfort of an apartment with the elegance of a villa.
                </p>
            </div>

            {/* Apartment Room with Villa Details */}
            <div className="row align-items-center">
                {/* Left - Image */}
                <div className="col-12 col-md-6 text-center mb-4 mb-md-0">
                    <img
                        src={apartmentVillaImage}
                        alt="Apartment Rooms with Villa"
                        className="img-fluid rounded shadow-lg"
                        style={{ borderRadius: '20px' }}
                    />
                </div>

                {/* Right - Description */}
                <div className="col-12 col-md-6">
                    <h2 className="fw-bold">About the Apartment Rooms with Villa</h2>
                    <p className="lead">
                        Our Apartment Rooms with Villa offer a harmonious blend of modern luxury and homely comfort, designed to provide a truly relaxing stay. Each space features a plush king-size bed for restful nights, a spacious bathroom with premium fittings, a fully equipped kitchen for your culinary needs, and a cozy living area perfect for unwinding. With full air-conditioning ensuring a comfortable atmosphere, this elegant retreat is ideal for solo travelers, couples, or business stays. Experience the perfect balance of style and functionality, making every moment of your stay both memorable and indulgent.
                    </p>
                    <ul className="list-unstyled">
                        <li>✔ King-size and twin beds for families</li>
                        <li>✔ Private terrace with garden views</li>
                        <li>✔ Fully equipped kitchen & dining area</li>
                        <li>✔ High-speed Wi-Fi and TV</li>
                        <li>✔ 24/7 room service and concierge</li>
                    </ul>
                    <h3 className="text-success fw-bold">$50 / Per Night</h3>
                    <a href="/booking" className="btn btn-success btn-lg mt-3">Book Now</a>
                </div>
            </div>

            {/* Room Details Section */}
            <section className="container my-5">
                {/* Title */}
                <div className="text-center mb-4">
                    <h1 className="fw-bold" style={{ color: "#819371" }}>Apartment Rooms with Villa</h1>
                    <p className="text-muted fs-5">Explore the different spaces in our villa.</p>
                </div>

                {/* Layout */}
                <div className="row align-items-center shadow p-4 rounded bg-light">
                    {/* Left - Image */}
                    <div className="col-12 col-md-6 text-center mb-4 mb-md-0">
                        <img
                            src={rooms[currentIndex].image}
                            alt={rooms[currentIndex].name}
                            className="img-fluid rounded shadow-lg"
                            style={{
                                width: "100%",
                                borderRadius: "20px",
                                transition: "opacity 0.8s ease-in-out",
                            }}
                        />
                    </div>

                    {/* Right - Room Descriptions */}
                    <div className="col-12 col-md-6">
                        <div className="list-group">
                            {rooms.map((room, index) => (
                                <div
                                    key={index}
                                    className={`list-group-item p-3 ${index === currentIndex ? "bg-success text-white fw-bold" : "bg-white"
                                        }`}
                                    style={{
                                        border: "1px solid #819371",
                                        borderRadius: "8px",
                                        marginBottom: "10px",
                                        transition: "background-color 0.5s ease-in-out",
                                    }}
                                >
                                    <h4 className="mb-1">
                                        <span style={{ fontSize: "1.5rem", marginRight: "10px" }}>
                                            {room.icon}
                                        </span>
                                        {room.name}
                                    </h4>
                                    <p className="mb-0">{room.description}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
        </section>
    );
};

export default ApartmentRoomsVilla;